import { getFileUrl } from '@/clients/http'
import { Image as ImageIcon } from 'lucide-react'

import { useBusiness } from '@/contexts/BusinessContext'

import { ProductModel } from '@/types/model/Product'

interface ProductVariationsTabProps {
  product: ProductModel.Product
}

export const ProductVariationsTab = ({ product }: ProductVariationsTabProps) => {
  const { formatCurrency } = useBusiness()

  if (!product.variations || product.variations.length === 0) {
    return <p className="py-12 text-center text-sm text-muted-foreground">No variations found for this product.</p>
  }

  return (
    <div className="divide-y divide-border-subtle overflow-hidden rounded-lg border border-border">
      {product.variations.map((variation, index) => {
        // Handle both snake_case and camelCase for attribute values
        const attributeValues =
          (variation as any).attribute_values || (variation as any).attributeValues || []

        return (
          <div key={variation._id || index} className="flex items-center gap-3 p-3 transition-colors hover:bg-subdued">
            <div className="flex size-10 shrink-0 items-center justify-center overflow-hidden rounded-md border border-border-subtle bg-subdued">
              {variation.images && variation.images.length > 0 ? (
                <img
                  src={getFileUrl(variation.images[0].path)}
                  alt={variation.name}
                  className="size-full object-cover"
                />
              ) : (
                <ImageIcon className="size-4 text-muted-foreground" />
              )}
            </div>
            <div className="min-w-0 flex-1">
              <p className="truncate text-sm font-medium text-ink">{variation.name}</p>
              <p className="text-xs text-muted-foreground">
                {attributeValues.map((av: any) => av.name).join(' / ')}
              </p>
            </div>
            <div className="whitespace-nowrap text-right">
              <p className="text-sm font-medium tabular-nums text-ink">{formatCurrency(variation.regular_price)}</p>
              <p className="text-xs tabular-nums text-muted-foreground">
                Stock: {variation.initial_stock_quantity || 0}
              </p>
            </div>
          </div>
        )
      })}
    </div>
  )
}
